import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterService } from 'src/app/components/master/services/master-service';
import { UpdateActionService } from './update-action.service';
import { CommonHelper } from 'src/app/helper/helper.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-update-action',
  templateUrl: './update-action.component.html',
  styleUrls: ['./update-action.component.scss']
})
export class UpdateActionComponent implements OnInit {
  @Input() grieveanceUpdateData: any;
  @Output() dataSubmitted = new EventEmitter<any>();
  actionData: any;
  fileData: any[] = [];
  actionGroup: FormGroup;
  roleId: any;
  stateId: any;
  constructor(
    private fb: FormBuilder,
    private masterService: MasterService,
    private updateActionService: UpdateActionService,
    private commonHelper: CommonHelper,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {

    this.getLocalData();
    this.validation();
  }

  getLocalData() {
    this.roleId = localStorage.getItem('roleId');
    this.stateId = localStorage.getItem('stateId');
  }

  validation() {
    if (this.roleId == 1) {
      this.actionGroup = this.fb.group({
        description: new FormControl('', Validators.required),
        fileUpload: new FormControl([], Validators.nullValidator),
        closed: new FormControl(0, Validators.required),
      })
    } else {
      this.actionGroup = this.fb.group({
        description: new FormControl('', Validators.required),
        fileUpload: new FormControl([], Validators.nullValidator),
      })
    }

  }
  get actionF() {
    return this.actionGroup.controls;
  }

  selectedFiles: File[] = []
  onFilesSelected(event: any) {


    const formData = new FormData();

    for (let i = 0; i < event.target.files.length; i++) {
      let files: File = event.target.files;
      var file = files[i];
      if (file.size > 5 * 1024 * 1024) {
        alert("File size must be less than 5MB");
        this.actionGroup.get('fileUpload').setValue(null);
        return;
      }
      this.selectedFiles.push(file);
    }



  }

  closePopup() {
    this.actionGroup.controls["description"].setValue([]);
    this.actionGroup.controls["fileUpload"].setValue([]);
  }

  // update actions
  onUpdate() {
    let formData = new FormData();
    if (this.roleId == 5) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append('file[]', this.selectedFiles[i]);
      }
      formData.append('comment', this.actionGroup.value.description);
      formData.append('levelId', '5');
      formData.append('grievanceId', String(this.grieveanceUpdateData.id));
      formData.append('isGrievanceRedressed', '');
      try {
        this.spinner.show();
        this.masterService.postData('level/grievance_action', formData).subscribe((response: any) => {
          if (response.status === 200 || 201) {
            this.updateActionService.close();
            this.spinner.hide();
            this.commonHelper.toasterMessage(response.message);
            this.actionGroup.controls["description"].setValue([]);
            this.actionGroup.controls["fileUpload"].setValue([]);
            this.dataSubmitted.emit();
          }
          else {
            this.updateActionService.close();
            this.spinner.hide();
            this.commonHelper.toasterMessageError(response.message);
            this.actionGroup.controls["description"].setValue([]);
            this.actionGroup.controls["fileUpload"].setValue([]);
          }
        })
      } catch (error) {
        this.spinner.hide();
        this.updateActionService.close();
        this.actionGroup.controls["description"].setValue([]);
        this.actionGroup.controls["fileUpload"].setValue([]);
      }

    } else if (this.roleId == 3) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append('file[]', this.selectedFiles[i]);
      }
      formData.append('comment', this.actionGroup.value.description);
      formData.append('levelId', '3');
      formData.append('grievanceId', String(this.grieveanceUpdateData.id));
      formData.append('isGrievanceRedressed', '');
      try {
        this.spinner.show();
        this.masterService.postData('level/grievance_action', formData).subscribe((response: any) => {
          if (response.status === 200 || 201) {
            this.updateActionService.close();
            this.spinner.hide();
            this.commonHelper.toasterMessage(response.message);
            this.actionGroup.reset();
            this.dataSubmitted.emit();
          }
          else {
            this.updateActionService.close();
            this.spinner.hide();
            this.commonHelper.toasterMessageError(response.message);
            this.actionGroup.reset();
          }
        })
      } catch (error) {
        this.updateActionService.close();
        this.spinner.hide();
        this.actionGroup.reset();
      }

    } else if (this.roleId == 1) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        formData.append('file[]', this.selectedFiles[i]);
      }
      formData.append('comment', this.actionGroup.value.description);
      formData.append('levelId', '1');
      formData.append('grievanceId', String(this.grieveanceUpdateData.id));
      formData.append('isGrievanceRedressed', this.actionGroup.value.closed);

      try {
        this.spinner.show();
        this.masterService.postData('level/grievance_action', formData).subscribe((response: any) => {
          if (response.status === 200 || 201) {
            this.updateActionService.close();
            this.commonHelper.toasterMessage(response.message);
            this.actionGroup.controls["description"].setValue([]);
            this.actionGroup.controls["fileUpload"].setValue([]);
            this.dataSubmitted.emit();
          }
          else {
            this.updateActionService.close();
            this.commonHelper.toasterMessageError(response.message);
            this.actionGroup.controls["description"].setValue([]);
            this.actionGroup.controls["fileUpload"].setValue([]);
          }
        })
      } catch (error) {
        this.updateActionService.close();
        this.actionGroup.controls["description"].setValue([]);
        this.actionGroup.controls["fileUpload"].setValue([]);
      }

    }


  }

}
